// Imports
import { Container, ComponentWrapper } from "@/components";

// iFrame Embed Code
export function IFrameEmbed({ type, iframe_source_url, iframe_height }) {
  // Render
  return (
    <ComponentWrapper type={type}>
      <Container fullHeight>
        <div className="w-full h-full p-5 bg-brand-wool rounded-lg">
          <iframe
            height={iframe_height ? iframe_height : "100%"}
            width="100%"
            scrolling="yes"
            seamless="seamless"
            src={iframe_source_url}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </Container>
    </ComponentWrapper>
  );
}
